module.exports = __webpack_public_path__ + "img/supervision_1280.d1d4203b.webp";